import {
  Input,
  Component,
  ElementRef,
  HostBinding,
  ContentChild,
  AfterViewInit,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SnIconComponent } from '@lib/ui/icon';

import { SnBaseButtonComponent } from '../../base/base-button.component';
import { SnButtonLabelDirective } from '../../directives/button-label.directive';

@Component({
  selector: 'sn-button, sn-flat-button, sn-outline-button',
  templateUrl: './button.component.html',
  inputs: ['disabled', 'color', 'tabIndex', 'type', 'isLoading'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.disabled]': 'isDisabledState',
    '[class.loading]': 'isLoadingState',
    '[attr.data-testid]': 'dataTestId',
  },
})
export class SnButtonComponent extends SnBaseButtonComponent implements AfterViewInit {
  public readonly tagName: string;

  @Input()
  public icon: string;

  @Input()
  public label: string;

  @Input()
  public tabIndex: number;

  @Input()
  public dataTestId: string;

  @HostBinding('class.sn-button')
  public readonly isButton: boolean;

  @HostBinding('class.sn-flat-button')
  public readonly isFlat: boolean;

  @HostBinding('class.sn-outline-button')
  public readonly isOutline: boolean;

  @ContentChild(SnIconComponent, { read: ElementRef })
  private readonly _icon: ElementRef<HTMLElement>;

  @ContentChild(SnButtonLabelDirective, { read: ElementRef })
  private readonly _label: ElementRef<HTMLElement>;

  constructor(elementRef: ElementRef<HTMLElement>) {
    super(elementRef);

    const tagName = this.hostElement.tagName.toLowerCase();
    this.tagName = tagName;
    this.isButton = tagName === 'sn-button';
    this.isFlat = tagName === 'sn-flat-button';
    this.isOutline = tagName === 'sn-outline-button';
    this.dataTestId = this.hostElement.getAttribute('data-testid');
  }

  get isDisabledState(): boolean {
    return this.disabled || this.isLoading;
  }

  get isLoadingState(): boolean {
    return this.isLoading && !this.disabled;
  }

  public ngAfterViewInit(): void {
    if (this._icon) {
      this._icon.nativeElement.classList.add('mat-button__icon');
    }

    if (this._label) {
      this._label.nativeElement.classList.add('mat-button__label');
    }
  }
}
